import { Button } from '@ahmdigital/ui';
import { connect } from 'react-redux';
import { Dispatch, SetStateAction, useEffect } from 'react';
import { Form, useFormikContext } from 'formik';
import { noop } from 'lodash/fp';

import { JourneyProductType } from '../../build-your-cover/types';
import { RootState } from '../../../reducers';
import RefinePriceFormFields from './refine-price-form-fields';
import selectExcessToggleValues from '../../../selectors/select-excess-toggle-values';

type RefinePriceFormProps = {
  captureFormState: {
    setFormikErrors: Dispatch<SetStateAction<{}>>;
    setFormikTouched: Dispatch<SetStateAction<{}>>;
  };
  handleChangeProductType: (productType: JourneyProductType) => void;
  hasSubmitAttempt: boolean;
};

const RefinePriceForm = ({ captureFormState, handleChangeProductType, hasSubmitAttempt }: RefinePriceFormProps) => {
  const { errors, handleSubmit, touched } = useFormikContext();
  const setFormikTouched = captureFormState?.setFormikTouched;
  const setFormikErrors = captureFormState?.setFormikErrors;

  // ErrorSummary component requires formik context values. This allows us to pass the errors and touched objects outside the LeadCaptureForm
  useEffect(() => {
    if (setFormikErrors) {
      setFormikErrors(errors);
    }
  }, [errors, setFormikErrors]);

  useEffect(() => {
    if (setFormikTouched) {
      setFormikTouched(touched);
    }
  }, [touched, setFormikTouched]);

  return (
    // @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ children: Element[]; onSubmit: (e?: FormEvent<HTMLFormElement> | undefined) => void; }' is missing the following properties from type 'Pick<DetailedHTMLProps<FormHTMLAttributes<HTMLFormElement>, HTMLFormElement>, "method" | "about" | ... 260 more ... | "onPointerLeaveCapture">': placeholder, onPointerEnterCapture, onPointerLeaveCapture
    <Form onSubmit={handleSubmit}>
      <RefinePriceFormFields handleChangeProductType={handleChangeProductType} hasSubmitAttempt={hasSubmitAttempt} />
      <Button
        icon={{
          name: 'arrow-right-long',
          position: 'right',
          size: 'large',
        }}
        type="submit"
        variant={['flair', 'wide']}
        //  The type of submit on this button handles the form submission.
        onClick={noop}
      >
        Find Cover
      </Button>
    </Form>
  );
};

const mapStateToProps = (state: RootState) => ({
  hospitalExcess: selectExcessToggleValues(state),
  location: state?.router?.location,
});

export default connect(mapStateToProps)(RefinePriceForm);
